<template>
	<div class="desktop-mobile-toggle" @click="$emit('onToggleClick')">
		<div class="toggle-container flex-centerize" :class="{ 'is-desktop': isDesktop }">
			<div class="svg-icon flex-centerize mr-3"><DesktopSVG /></div>
			<div class="svg-icon flex-centerize ml-3"><MobileSVG /></div>
			<div class="toggle-handle"></div>
		</div>
	</div>
</template>

<script>
import DesktopSVG from './assets/DesktopSVG';
import MobileSVG from './assets/MobileSVG';

export default {
	name: 'DesktopMobileToggle',
	components: {
		DesktopSVG,
		MobileSVG,
	},
	props: {
		isDesktop: { type: Boolean },
	},
};
</script>

<style scoped lang="scss">
.desktop-mobile-toggle .toggle-container {
	position: relative;
	padding: 9px 18px 10px 18px;
	border: 1px solid #dce0eb;
	border-radius: 30px;
	background-color: #f5f8fe;

	.svg-icon {
		width: 24px;
		z-index: 9999;
	}

	.toggle-handle {
		position: absolute;
		top: 3px;
		height: 32px;
		width: 52px;
		border: 1px solid #dce0eb;
		border-radius: 30px;
		background-color: #ffffff;
		box-shadow: var(--card-shadow);
		z-index: 99;
	}

	&.is-desktop .toggle-handle {
		left: 3px;
	}
	&:not(.is-desktop) .toggle-handle {
		left: 50px;
	}

	&:hover {
		cursor: pointer;
		.toggle-handle {
			box-shadow: var(-box-shadow-dark);
			filter: brightness(95%);
			// background: var(--subtle-hover-bg-color);
			transition: 0.2s;
		}
	}
}
</style>
